/* eslint-disable max-lines */

// bottom is requested
// top is confirmed (by vendor)

export const mockWorkCenters = [
  {
    workCenter: 'KFRTWELD',
    description: 'KRL-Froth Welder',
    area: 'UT2',
    role: 'Welder',
    company: 'Some Company',
    revision: 'K1SL2202',
    Dates: [
      {
        Date: '2023-01-02', // monday
        confirmed: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-03', // tuesday
        confirmed: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 1,
            Night: 4
          }
        },
        requested: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-04', // wednesday
        confirmed: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 1,
            Night: 4
          }
        },
        requested: {
          Incremental: {
            Day: 2,
            Night: 1
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-05', // thursday
        confirmed: {
          Incremental: {
            Day: 99,
            Night: 99
          },
          Baseline: {
            Day: 99,
            Night: 99
          }
        },
        requested: {
          Incremental: {
            Day: 80,
            Night: 20
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-06', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-07', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-08', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-09', // monday
        confirmed: {
          Baseline: {
            Day: 10
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-10', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-11', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 11,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-12', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-13', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-14', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-15', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-16', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-17', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-18', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-19', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-20', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-21', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-22', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      }
    ],
    id: '441fe54a-094d-478d-a682-19aeb45240f1'
  },
  {
    workCenter: 'KFRTPIPE',
    description: 'KRL-Utilities Pipefitter',
    area: 'FR1',
    role: 'Electrician',
    company: 'Some Company Here',
    revision: 'K1SL2202',
    Dates: [
      {
        Date: '2023-01-02', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-03', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-04', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-05', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-06', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-07', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-08', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-09', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-10', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-11', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-12', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-13', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-14', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-15', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-16', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-17', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-18', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-19', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-20', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-21', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-22', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      }
    ],
    id: '441fe54a-094d-478d-a682-19aeb45240f1'
  },
  {
    workCenter: 'KFRTELEC',
    description: 'KRL-Froth Electrician',
    area: 'EX1',
    role: 'Scaffolder',
    company: 'Some Another Company with the long name',
    revision: 'K1SE2202',
    Dates: [
      {
        Date: '2023-01-02', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-03', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-04', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-05', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-06', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-07', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-08', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-09', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-10', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-11', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-12', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-13', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-14', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-15', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-16', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-17', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-18', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-19', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-20', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-21', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-22', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      }
    ],
    id: '441fe54a-094d-478d-a682-19aeb45240f1'
  },
  {
    workCenter: 'KURSCAF',
    description: 'KRL - Unit Rate Scaffolder',
    area: 'UT2',
    role: 'Welder',
    company: 'Some Company Again',
    revision: 'K1SE2202',
    Dates: [
      {
        Date: '2023-01-02', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-03', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-04', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-05', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-06', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-07', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-08', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-09', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-10', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-11', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-12', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-13', // friday
        confirmed: {
          Incremental: {
            Day: 3,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-14', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-15', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-16', // monday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-17', // tuesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-18', // wednesday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-19', // thursday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 7,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-20', // friday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-21', // saturday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      },
      {
        Date: '2023-01-22', // sunday
        confirmed: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        },
        requested: {
          Incremental: {
            Day: 4,
            Night: 2
          },
          Baseline: {
            Day: 10,
            Night: 5
          }
        }
      }
    ],
    id: '441fe54a-094d-478d-a682-19aeb45240f1'
  }
];
